import React from 'react';
import Carousel from 'Common/components/Molecules/Carousel';
import { Col, Flex } from 'Common/components/Atoms/Flex';
import { Link } from 'Common/components/Atoms/Link';
import { Text } from 'Common/components/Atoms/Text';
import { Testimonial } from './Testimonial';
import { styled, useTheme } from '@mui/material';
import { LANDING } from 'DisplayText/ReviewerOnboarding';
import daveImage from '../assets/dave-ivell.png';
import markImage from '../assets/mark-mullan.png';
import alainImage from '../assets/alain-c.png';

const Section = styled(Col)(({ theme }) => ({
  marginRight: 155,
  width: 445,
  [theme.breakpoints.down('lg')]: {
    marginBottom: 48,
    marginRight: 0,
    textAlign: 'center',
    width: 600,
  },
}));

const Title = styled(Text)(({ theme }) => ({
  '&&&&': {
    fontSize: 36,
    marginBottom: 16,
    color: theme.palette.text.primary,
    [theme.breakpoints.down('lg')]: {
      marginBottom: 32,
    },
  },
}));

const Description = styled(Text)(({ theme }) => ({
  '&&&&': {
    marginTop: 8,
    fontSize: 16,
    color: theme.palette.text.secondary,
    [theme.breakpoints.down('lg')]: {
      fontSize: 20,
    },
  },
}));

const scrollId = 'what-is-pullrequest';
export const scrollIdSelector = `#${scrollId}`;

export const Testimonials = () => {
  const theme = useTheme();

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      backgroundColor={theme.palette.background.default}
      flexWrap="wrap"
      id={scrollId}
      p={6}
    >
      <Section>
        <Title>{LANDING.WHAT_IS_PULLREQUEST}</Title>
        <Description>{LANDING.PULL_REQUEST_DESCRIPTION_1}</Description>
        <Description>{LANDING.PULL_REQUEST_DESCRIPTION_2}</Description>
      </Section>
      <Flex flexDirection="column" width={620}>
        <Carousel>
          <Testimonial
            imageHref={daveImage}
            quote={LANDING.DAVE_IVELL_QUOTE}
            founder={LANDING.DAVE_IVELL_FOUNDER}
            title={
              <Text>
                Founder &amp; CEO,{' '}
                <Link href="https://www.getcroissant.com/" target="_blank">
                  Croissant
                </Link>
              </Text>
            }
          />
          <Testimonial
            imageHref={markImage}
            quote={LANDING.MARK_MULLAN_QUOTE}
            founder={LANDING.MARK_MULLAN_FOUNDER}
            title={
              <Text>
                Sr. Engineer,{' '}
                <Link href="https://www.clover.com/" target="_blank">
                  Clover
                </Link>
              </Text>
            }
          />
          <Testimonial
            imageHref={alainImage}
            quote={LANDING.ALAIN_CHAUTARD_QUOTE}
            founder={LANDING.ALAIN_CHAUTARD_FOUNDER}
            title={
              <Text>
                Angular Expert,{' '}
                <Link href="https://www.angulartraining.com/" target="_blank">
                  Angular Training
                </Link>
              </Text>
            }
          />
        </Carousel>
      </Flex>
    </Flex>
  );
};
